import { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { range } from '../../../../helpers/common'
import { Element } from '../../../html/element'
import { Icon } from '../../../html/icon'
import { SelectCustom } from '../../../selectCustom'
import { TextEllipsisStaticLine } from '../../../textEllipsis/TextEllipsisStaticLine'
import { Tooltip } from '../../../tooltip'
import { AUDIT_STATUS_OPTIONS, METHOD_OPTIONS, TABLE_KEYS } from '../constants'
import { selectDataAvailabilityDetails } from '../store/slice'
import { getDataAvailability } from '../store/thunk'
import useGetOrganizationId from '../useGetOrganizationId'
import classes from './index.module.scss'

export const TableContent = ({ orgId }) => {
  const dispatch = useDispatch()

  const organizationId = useGetOrganizationId(orgId)

  const data = useSelector(selectDataAvailabilityDetails)

  const getBackgroundColor = (index) => {
    return index % 2 === 0 ? '' : '#F3F3F3'
  }

  const getActiveItemAuditStatus = (value) => {
    return AUDIT_STATUS_OPTIONS.find((item) => item.value === value) || {}
  }

  const getActiveItemMethod = (value) => {
    return METHOD_OPTIONS.find((item) => item.value === value) || {}
  }

  const getParamsGetDataAvailability = (year, key, value) => {
    const years = []
    const methods = []
    const auditStatuses = []
    let isConsolidated = true
    let sourceOrganizationId = ''

    data.forEach((item) => {
      if (key === 'audited' && year === item.year) {
        auditStatuses.push({ year: item.year, isAudit: value })
      } else {
        auditStatuses.push({ year: item.year, isAudit: item.audited })
      }

      if (key === 'isDirect' && year === item.year) {
        methods.push({ year: item.year, isDirect: value })
      } else {
        methods.push({ year: item.year, isDirect: item.isDirect })
      }

      years.push(item.year)
      isConsolidated = item.consolidated
      sourceOrganizationId = item.sourceOrganizationId
    })

    return {
      organizationId,
      sourceOrganizationId,
      isConsolidated,
      years,
      methods,
      auditStatuses,
    }
  }

  const onSelectAuditStatus = (year, item) => {
    dispatch(
      getDataAvailability(
        getParamsGetDataAvailability(year, 'audited', item.value),
      ),
    )
  }

  const onSelectMethod = (year, item) => {
    dispatch(
      getDataAvailability(
        getParamsGetDataAvailability(year, 'isDirect', item.value),
      ),
    )
  }

  return (
    <div
      style={{
        gap: 2,
        display: 'grid',
        gridTemplateColumns: range(0, data.length)
          .map((_) => 'auto')
          .join(' '),
      }}
    >
      {Object.keys(TABLE_KEYS).map((key, index) => (
        <Fragment key={key}>
          <div
            className={['dFlex alignItemsCenter', classes.px12py4].join(' ')}
            style={{ backgroundColor: getBackgroundColor(index) }}
          >
            <TextEllipsisStaticLine
              isI18n
              zIndexTooltip={13}
              lineClamp={1}
              text={'domesticSearchPreview.' + key}
            />
            {TABLE_KEYS[key] === TABLE_KEYS.DATA_AVAILABILITY && (
              <Tooltip
                tooltipContent="domesticSearchPreview.CHECK_DATA_AVAILABILITY_CONDITIONS"
                isI18n
                contentClass="ml1"
                zIndex={13}
              >
                <Icon
                  className="icon-info-circle"
                  style={{ color: '#9C9C9C', fontSize: 13 }}
                />
              </Tooltip>
            )}
          </div>
          {data.map((item, itemIndex) => (
            <Element
              elementName="div"
              key={itemIndex}
              style={{ backgroundColor: getBackgroundColor(index) }}
            >
              {TABLE_KEYS[key] === TABLE_KEYS.REPORTING_YEAR && (
                <div
                  className={['dFlex alignItemsCenter', classes.px12py4].join(
                    ' ',
                  )}
                >
                  {item.year}
                </div>
              )}
              {TABLE_KEYS[key] === TABLE_KEYS.AUDIT_STATUS && (
                <SelectCustom
                  zIndex={13}
                  className="h100"
                  activeItem={getActiveItemAuditStatus(
                    item.audited === undefined ? true : item.audited,
                  )}
                  data={AUDIT_STATUS_OPTIONS}
                  chooseItem={(value) => onSelectAuditStatus(item.year, value)}
                  disabled={item.isDisable}
                  isI18n
                  isNoWrap
                  renderActiveItem={(activeItem) => (
                    <span>
                      <Translate value={activeItem.label || ''} />
                    </span>
                  )}
                />
              )}
              {TABLE_KEYS[key] === TABLE_KEYS.METHOD && (
                <SelectCustom
                  zIndex={13}
                  className="h100"
                  activeItem={getActiveItemMethod(item.isDirect || false)}
                  data={METHOD_OPTIONS}
                  chooseItem={(value) => onSelectMethod(item.year, value)}
                  disabled={item.isDisable}
                  isI18n
                  isNoWrap
                  renderActiveItem={(activeItem) => (
                    <span>
                      <Translate value={activeItem.label || ''} />
                    </span>
                  )}
                />
              )}
              {TABLE_KEYS[key] === TABLE_KEYS.DATA_AVAILABILITY && (
                <div className="dFlex alignItemsCenter justifyContentCenter h100">
                  <Icon
                    className={
                      item.available
                        ? 'icon-tick-circle-fill'
                        : 'icon-delete-circle-fill'
                    }
                    style={{
                      fontSize: 13,
                      color: item.available ? '#3DA967' : '#E0505B',
                    }}
                  />
                </div>
              )}
            </Element>
          ))}
        </Fragment>
      ))}
    </div>
  )
}
